module.exports = __webpack_public_path__ + "img/grafiti-crown.f7bb504f.png";